module.exports = __webpack_public_path__ + "dd780f4051714706ec7a71db7c517922.fbx";